<script>
    import { afterUpdate } from 'svelte'
    import Item from './Item.svelte'
    import { db } from '../../lib/firebase'
    import { collectionData } from 'rxfire/firestore'
    import { startWith } from 'rxjs/operators'

    // export let uid

    let name = 'some client name'

    // const query = db.collection('classes').where(/*'uid', '==', uid*/).orderBy('name')
    const query = db.collection('clients').orderBy('name')
    const clients = collectionData(query, 'id').pipe(startWith([]))

    function add() {
      let newClient = {
        name: name,
        created: Date.now(),
        updated: Date.now()
      }
      db.collection('clients').add(newClient)
      name = ''
    }

    function updateItem(event) {
        console.log(event)
        const { id } = event.detail
        db.collection('clients').doc(id).update({ updated: Date.now() })
    }

    function removeItem(event) {
        const { id } = event.detail;
        db.collection('clients').doc(id).delete();
    }

</script>

<style>
    input { display: block }
</style>

<ul>
	{#each $clients as client}
    <Item {...client} on:remove={removeItem} on:toggle={updateItem} />
	{/each}
</ul>

<input bind:value={name}>

<hr>

<p>Client name: <strong>{ name }</strong></p>

<button class="button is-info" on:click={add}>Add Client</button>